module.exports = __webpack_public_path__ + "img/Group 104.f41f17f2.png";